<template>
    <div>
        <avue-crud :data="data"  ref="crud" :option="option">
            <template slot="all_url" slot-scope="scope">
<!--                <span>{{scope.row.all_url}}</span>-->
                <el-image
                    v-if="scope.row.file_type==1&&scope.row.all_url!=''"
                    style="width: 50px; height: 50px"
                    :src="scope.row.all_url"
                    :preview-src-list="[scope.row.all_url]">
                </el-image>
                <audio v-if="scope.row.file_type==2" :src="scope.row.all_url" controls></audio>
                <span v-if="scope.row.file_type==1&&scope.row.all_url==''">暂无数据</span>
            </template>
        </avue-crud>
    </div>
</template>

<script>
import { cluesRecord } from '@/api/callCenter';

export default {
    name: 'followUpRecord',
    data() {
        return {
            listArgument:{
                id:this.$route.query.id,
                limit:50,
                page:1
            },
            data:[],
            option: {
                stripe: true,
                // index:true,
                searchMenuSpan: 3,
                indexLabel: '序号',  //添加序号
                selection: false, //批量选择
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menu:false,
                menuType: 'menu',
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '跟进记录ID',
                        prop: 'id'
                    },
                    {
                        label: '姓名',
                        prop: 'name'
                    },
                    {
                        label: '公司',
                        prop: 'com_name'
                    },
                    {
                        label: '跟进人',
                        prop: 'mobile'
                    },
                    {
                        label: '跟进类型',
                        prop: 'genjin_type_txt'
                    },
                    {
                        label: '备注内容',
                        prop: 'remark'
                    },
                    // {
                    //     label: '文件类型',
                    //     prop: 'file_type'
                    // },
                    {
                        label: '文件',
                        prop: 'all_url',
                        width: '350'
                    },
                    {
                        label: '跟进时间',
                        prop: 'create_time'
                    },
                ]
            }
        };
    },
    created() {
        cluesRecord(this.listArgument).then(res=>{
            if (res.code == 200) {
                this.data = res.data.list
            }else {
                this.$message.error(res.msg)
            }
        })
    }
}
</script>

<style scoped lang="scss">
::v-deep .avue-crud__menu{
    min-height: 0px;
}
</style>